import type { ProgramQuote } from '@makemydeal/dr-dash-types';

// Truthy (not `??`) so empty-string lenderLegalName falls back to the code instead of rendering blank.
export const formatLenderName = (record: ProgramQuote): string => {
    return record.lenderLegalName ? record.lenderLegalName : record.lenderCode ?? '';
};

export const formatProgramDisplay = (record: ProgramQuote): string => {
    if (record.lenderProgram?.programName) {
        return record.lenderProgram.programName;
    }
    if (record.lenderProgram?.rateProgram) {
        return record.lenderProgram.rateProgram;
    }
    return '';
};

export const formatRateProgramDesc = (record: ProgramQuote): string => record.lenderProgram?.rateProgramDesc ?? '';

export const formatProgramType = (record: ProgramQuote): string => record.lenderProgram?.programType ?? '';

export const formatRegionalTitle = (record: ProgramQuote): string => record.lenderProgram?.regionalTitle || '';

export const formatRateProgram = (record: ProgramQuote): string => record.lenderProgram?.rateProgram || 'Basic';
